export default function FeesIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.4379 5.375C14.4379 4.65013 13.8503 4.0625 13.1254 4.0625H2.96289C2.44512 4.0625 2.02539 4.48223 2.02539 5M2.02539 5L2.02539 13.4375C2.02539 14.2659 2.69696 14.9375 3.52539 14.9375H14.4004C15.2288 14.9375 15.9004 14.2659 15.9004 13.4375V7.4375C15.9004 6.60907 15.2288 5.9375 14.4004 5.9375H2.96289C2.44512 5.9375 2.02539 5.51777 2.02539 5ZM12.9379 10.4375C12.9379 10.7482 12.6861 11 12.3754 11C12.0648 11 11.8129 10.7482 11.8129 10.4375C11.8129 10.1268 12.0648 9.875 12.3754 9.875C12.6861 9.875 12.9379 10.1268 12.9379 10.4375Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
